import type { HTMLAttributes, ReactNode } from 'react';

import { memo } from 'react';

import classes from './style.module.scss';

interface ModalBodyProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  className?: string;
}

const ModalBody = memo<ModalBodyProps>(function ModalBody({ children, className, ...attrs }) {
  return (
    <div className={[classes['Modal-Body'], className || ''].join(' ')} {...attrs}>
      {children}
    </div>
  );
});

export default ModalBody;
